'use client';

import { type HTMLAttributes } from 'react';
import { Heading } from '@paypoteam/ui-components/Heading';

export interface H1Props extends HTMLAttributes<HTMLHeadingElement> {}

export default function H5({ children, ...props }: H1Props) {
    return (
        <Heading
            type="h5"
            size="2xl"
            {...props}
        >
            {children}
        </Heading>
    );
}
